import React from 'react';
import { StyleSheet } from 'react-native';
import { Ledger as LedgerComponent } from '@sg/garnish';
import type { Ledger } from '@sg/graphql-schema';

import { useLedgerLineItems } from '../../hooks';

// ────────────────────────────────────────────────────────────────────────────────

export const OrderStatusLedger = (props: OrderStatusLedgerProps) => {
  const { ledger } = props;

  const ledgerTip = ledger.tip ?? 0;
  const ledgerItems = useLedgerLineItems({
    ledger,
    showTip: ledgerTip > 0,
    showTotal: true,
    showTaxes: true,
    showReward: true,
  });

  return (
    <LedgerComponent
      style={styles.ledger}
      hasTopBorder={true}
      items={ledgerItems}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  ledger: {
    paddingBottom: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type OrderStatusLedgerProps = {
  ledger: Partial<Ledger>;
};
